import keyBy from 'lodash/keyBy';

export function clipsBySceneIds(clips, sceneIds) {
  const result = {};

  clips.map(clip => {
    if (!sceneIds.includes(clip.scene_id)) {
      return;
    }
    const res = result[clip.scene_id] || [];
    res.push(clip);
    result[clip.scene_id] = res;
  });

  return result;
}

export function clipsByClipIds(clips, clipIds) {
  const indexed = keyBy(clips, 'clip_id');
  return clipIds.map(id => clips[id]);
}

export function clipsIdsToX(clips, clipIds, x) {
  const filterToIds = clipsByClipIds(clips, clipIds);
  return filterToIds.map(clip => clip && clip[x]);
}



// WEBPACK FOOTER //
// ./src/lib/clips.js